import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  permissions: null,
  roles: null,
  statuses: null,
  directions: null,
  documents: null,
  educationTypes: null,
  educationMethods: null,
  users: null,
  questionTypes: null,
  testTypes: null,
  subjectTypes: null,
  attemptQuestionStatuses: null,
  documentsStatuses: null,
  pollStatuses: null
}

// getters
export const getters = {
  permissions: state => state.permissions,
  roles: state => state.roles,
  statuses: state => state.statuses,
  directions: state => state.directions,
  documents: state => state.documents,
  educationTypes: state => state.educationTypes,
  educationMethods: state => state.educationMethods,
  users: state => state.users,
  questionTypes: state => state.questionTypes,
  testTypes: state => state.testTypes,
  subjectTypes: state => state.subjectTypes,
  attemptQuestionStatuses: state => state.attemptQuestionStatuses,
  documentsStatuses: state => state.documentsStatuses,
  pollStatuses: state => state.pollStatuses
}

// mutations
export const mutations = {

  [types.FETCH_PERMISSIONS] (state, { permissions }) {
    state.permissions = permissions
  },
  [types.FETCH_ROLES] (state, { roles }) {
    state.roles = roles
  },
  [types.FETCH_STATUSES] (state, { statuses }) {
    state.statuses = statuses
  },
  [types.FETCH_DIRECTIONS] (state, { directions }) {
    state.directions = directions
  },
  [types.FETCH_DOCUMENTS] (state, { documents }) {
    state.documents = documents
  },
  [types.FETCH_EDUCATION_TYPES] (state, { educationTypes }) {
    state.educationTypes = educationTypes
  },
  [types.FETCH_EDUCATION_METHODS] (state, { educationMethods }) {
    state.educationMethods = educationMethods
  },
  [types.FETCH_USERS] (state, { users }) {
    state.users = users
  },
  [types.FETCH_QUESTION_TYPES] (state, { questionTypes }) {
    state.questionTypes = questionTypes
  },
  [types.FETCH_TEST_TYPES] (state, { testTypes }) {
    state.testTypes = testTypes
  },
  [types.FETCH_SUBJECT_TYPES] (state, { subjectTypes }) {
    state.subjectTypes = subjectTypes
  },
  [types.FETCH_ATTEMPT_QUESTION_STATUSES] (state, { attemptQuestionStatuses }) {
    state.attemptQuestionStatuses = attemptQuestionStatuses
  },
  [types.FETCH_DOCUMENTS_STATUSES] (state, { documentsStatuses }) {
    state.documentsStatuses = documentsStatuses
  },
  [types.FETCH_POLL_STATUSES] (state, { pollStatuses }) {
    state.pollStatuses = pollStatuses
  }
}

// actions
export const actions = {
  async fetchPermissions ({ commit }) {
    const { data } = await axios.get('/api/access/permissions', { params: { per_page: 9999 } })
    commit(types.FETCH_PERMISSIONS, { permissions: data.data })
  },
  async fetchRoles ({ commit }) {
    const { data } = await axios.get('/api/access/roles', { params: { per_page: 9999 } })
    commit(types.FETCH_ROLES, { roles: data.data })
  },
  async fetchStatuses ({ commit }) {
    const { data } = await axios.get('/api/directories/statuses', { params: { per_page: 9999 } })
    commit(types.FETCH_STATUSES, { statuses: data.data })
  },
  async fetchDirections ({ commit }) {
    const { data } = await axios.get('/api/directories/directions', { params: { per_page: 9999 } })
    commit(types.FETCH_DIRECTIONS, { directions: data.data })
  },
  async fetchDocuments ({ commit }) {
    const { data } = await axios.get('/api/directories/documents', { params: { per_page: 9999 } })
    commit(types.FETCH_DOCUMENTS, { documents: data.data })
  },
  async fetchEducationTypes ({ commit }) {
    const { data } = await axios.get('/api/types/education-types')
    commit(types.FETCH_EDUCATION_TYPES, { educationTypes: data.data })
  },
  async fetchEducationMethods ({ commit }) {
    const { data } = await axios.get('/api/types/education-methods')
    commit(types.FETCH_EDUCATION_METHODS, { educationMethods: data.data })
  },
  async fetchUsers ({ commit }) {
    const { data } = await axios.get('/api/access/users')
    commit(types.FETCH_USERS, { users: data.data })
  },
  async fetchQuestionTypes ({ commit }) {
    const { data } = await axios.get('/api/types/question-types')
    commit(types.FETCH_QUESTION_TYPES, { questionTypes: data.data })
  },
  async fetchTestTypes ({ commit }) {
    const { data } = await axios.get('/api/types/test-types')
    commit(types.FETCH_TEST_TYPES, { testTypes: data.data })
  },
  async fetchSubjectTypes ({ commit }) {
    const { data } = await axios.get('/api/types/subject-types')
    commit(types.FETCH_SUBJECT_TYPES, { subjectTypes: data.data })
  },
  async fetchAttemptQuestionStatuses ({ commit }) {
    const { data } = await axios.get('/api/types/attempt-question-statuses')
    commit(types.FETCH_ATTEMPT_QUESTION_STATUSES, { attemptQuestionStatuses: data.data })
  },
  async fetchDocumentsStatuses ({ commit }) {
    const { data } = await axios.get('/api/types/documents-statuses')
    commit(types.FETCH_DOCUMENTS_STATUSES, { documentsStatuses: data.data })
  },
  async fetchPollStatuses ({ commit }) {
    const { data } = await axios.get('/api/types/poll-statuses')
    commit(types.FETCH_POLL_STATUSES, { pollStatuses: data.data })
  }
}
